import defaultHeaders from '@/store/modules/users/entities/defaultHeaders';
const defaultState = () => ({
    defaultHeaders,
    selectItems: [],
    selectTitle: '',
    selectLoading: false,
    fieldsLoading: true
});
export default defaultState;
